<script>
    import app from "../lib/stores/app.js";
    import {PAYMENT_TYPE} from "../lib/js/constants.js";
    import {emptyReservation} from "../lib/js/reservation.js";
    import {getDepartmentCode, scrollToTop} from "../lib/js/utils.js";
    import PageHeader from "../lib/components/PageHeader.svelte";
    import Step1 from "./Step1.svelte";
    import CheckoutPage from "../book/CheckoutPage.svelte";

    let reservation = emptyReservation();

    let offer = null;
    let step = 1;

    const initialize = () => {
        if (!$app.offer) {
            const link_code = getDepartmentCode();
            window.location.href = `/${link_code}`;
            return;
        }

        offer = $app.offer;

        reservation.offer_id = offer.id;
        reservation.title = offer.name;
        reservation.vehicle = offer.vehicle;
        reservation.start_price = offer.vehicle.start_price;
        reservation.price = offer.vehicle.price;
        reservation.payment_type = PAYMENT_TYPE.CARD;
        reservation.routes = offer.routes;
    }

    const onPreviousStep = step_no => {
        step = step_no;
        scrollToTop();
    }

    const onNextStep = step_no => {
        step = step_no;
        scrollToTop();
    }

    initialize();
</script>

<PageHeader title="Transfer reservation"/>

<div class="container py-lg">
    {#if offer != null}
        {#if step == 1}
            <Step1 {offer} bind:reservation onNext={() => onNextStep(2)}/>
        {/if}
        {#if step == 2}
            <CheckoutPage bind:reservation onBack={() => onPreviousStep(1)}/>
        {/if}
    {/if}
</div>